<generic-modal #editBinder [hideOnBackdropClick]="false" [isFullHeight]="true">
	<ng-template #modalHeading>
		<div class="header-container">
			<div class="name-container">
				<span>Edit Binder</span>
			</div>
			<button mat-button (click)="close()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</ng-template>
	<ng-template #modalBody let-data="years">
		<div class="main-container">
			<app-loader *ngIf="isFormSubmitted"></app-loader>
			<form class="main-form disable-form" [formGroup]="editBinderForm" id="editBinder">
				<div *ngIf="!binderDetails.isYearless" class="year-selection">
					<span>Year:</span>
					<mat-form-field class="container">
						<mat-select formControlName="year" [disabled]="isDataLoading || isJobLoading || isFormSubmitted">
							<mat-option *ngFor="let year of years" [value]="year">
								{{year}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="binder-selection">
					<div class="main-form">
						<div class="selection-container">
							<span>Tab:</span>
							<mat-form-field [floatLabel]="'never'">
								<mat-select formControlName="parent" [disabled]="isDataLoading || isJobLoading || isFormSubmitted" placeholder="Select a tab">
									<ng-container *ngFor="let item of binderParents">
										<mat-option *ngIf="!isDataLoading" [value]="item" (click)="getForms(item.binderClassificationId)">
											{{ item.binderName }}
										</mat-option>
									</ng-container>
								</mat-select>
							</mat-form-field>
						</div>
		
						<mat-form-field *ngIf="selectedBinderChildren?.length && !isDataLoading" class="child-form-field" [floatLabel]="'never'">
							<mat-select formControlName="child" [disabled]="isDataLoading || isJobLoading || isFormSubmitted">
								<mat-option *ngFor="let item of selectedBinderChildren" [value]="item" (click)="getForms(item.binderClassificationId)">
									{{ item.binderName }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
				<div class="form-selection main-form">
					<span>Select Form:</span>
					<mat-form-field class="container" [floatLabel]="'never'">
						<mat-select [floatLabel]="'never'" formControlName="form" [disabled]="isDataLoading || !forms || isJobLoading || isFormSubmitted" placeholder="Select a form to edit data">
							<ng-container *ngIf="forms.length == 0">
								<mat-option>There are no forms for the current Tab.</mat-option>
							</ng-container>
							<ng-container *ngFor="let item of forms">
								<mat-option [floatLabel]="'never'" *ngIf="!isDataLoading" [value]="item" (click)="getJobs(item.formTemplateId)">
									{{ item.name }}
								</mat-option>
							</ng-container>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="job-selection main-form">
					<span>Select Job:</span>
					<fieldset>
						<app-loader *ngIf="isJobLoading"></app-loader>
						<ng-container *ngIf="jobs != null">
							<mat-selection-list #jobsList [dataSource]="jobs" [multiple]="false" >
								<mat-list-option  *ngFor="let item of jobs" [value]="item" 
								(click)="initializeFormTemplate(item)" [disabled]="isFormSubmitted">
									<span [ngClass]="{'missed-form': !item.hasFormData}">{{moment.parseZone(item.customerEtaDate).format("MMM DD, YYYY")}} - {{item.jobName}}</span>
								</mat-list-option>
							</mat-selection-list>
						</ng-container>
						<ng-container class="text" *ngIf="!isJobLoading && jobs.length == 0 && this.isJobsEmpty">
							<span>There are no jobs for the current Form. Please select another one.</span>
						</ng-container>
						<ng-container class="text" *ngIf="!isJobLoading && jobs.length == 0 && !this.isJobsEmpty">
							<span>Please select a Form.</span>
						</ng-container>
					</fieldset>
				</div>
			</form>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-button (click)="openFormViewer()" form="editBinderForm" [disabled]="editBinderForm.get('job').value == null">Update Form Data</button>
	</ng-template>
</generic-modal>

<generic-modal #formsModal>
	<ng-template #modalBody>
		<form-viewer *ngIf="selectedFormTemplate" [formTemplate]="selectedFormTemplate"
		(afterLoading)="currentFormViewer = $event" [submitFormCallback]="onSubmit.bind(self)" [isReadOnly]="false"></form-viewer>
	</ng-template>

	<ng-template #modalActions>
		<button mat-flat-button class="primary" (click)="currentFormViewer.submit();">Submit</button>
		<button mat-flat-button (click)="resetSelection(); jobsList.deselectAll();">Cancel</button>
	</ng-template>
</generic-modal>

<generic-modal #infoModal [hideOnBackdropClick]="false">
	<ng-template #modalBody>
		<span>
			It may take a few moments for your changes to be reflected in the Binder.
		</span>
	</ng-template>
</generic-modal>
